<div class="task-requests-detail">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-2">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal" #top>
          Solicitud
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <!-- body content -->
  <div *ngIf="!loading" style="border-top: 1px solid #B1AFC1;">
    <div class="row font-manax">
      <div class="col-12 py-3">
        <div class="row px-3 text-purple-manax bold-item" style="font-size: 1.5rem;">
          {{ taskRequest.client?.lastname ? taskRequest.client?.firstname + " " + taskRequest.client?.lastname : taskRequest.client?.firstname}}
          <span *ngIf="taskRequest?.agent?.name">&nbsp;{{"/ " + taskRequest.agent?.name}}</span>
          <span *ngIf="!taskRequest?.agent?.name"> </span>
        </div>
      </div>
    </div>

    <div class="row my-3 font-manax">
      <div class="col-12 pb-3">
        <h5 class="m-0">
          <i class="material-icons task-icon-color">calendar_today</i><b class="bold-item">&nbsp;Solicitado
            el:&nbsp;</b>
          {{taskRequest.createdAt | date:'dd/MM/yyyy' }}
        </h5>
      </div>
    </div>

    <div class="row my-3 font-manax" *ngIf="taskRequest?.client?.address">
      <div class="col-12 pb-3">
        <h5 class="m-0">
          <i class="material-icons task-icon-color">place</i><b class="bold-item">&nbsp;Dirección:&nbsp;</b>
          {{taskRequest.client?.address}}
        </h5>
      </div>
    </div>

    <div class="row my-3 font-manax" *ngIf="taskRequest?.client?.phone">
      <div class="col-12 pb-3">
        <h5 class="m-0">
          <i class="material-icons task-icon-color">local_phone</i><b class="bold-item">&nbsp;Teléfono:&nbsp;</b>
          {{taskRequest.client?.phone}}
        </h5>
      </div>
    </div>

    <div class="row my-3 font-manax" *ngIf="taskRequest?.client?.email">
      <div class="col-12 pb-3">
        <h5 class="m-0">
          <i class="material-icons task-icon-color">alternate_email</i><b class="bold-item">&nbsp;Email:&nbsp;</b>
          {{taskRequest.client?.email}}
        </h5>
      </div>
    </div>

    <div class="row my-3 font-manax" *ngIf="taskRequest?.title">
      <div class="col-12 pb-3">
        <h5 class="m-0">
          <i class="material-icons task-icon-color">featured_play_list</i><b class="bold-item">&nbsp;Asunto:&nbsp;</b>
          {{taskRequest.title}}
        </h5>
      </div>
    </div>

    <div class="row my-3 font-manax" *ngIf="taskRequest?.description">
      <div class="col-12 pb-3">
        <h5 class="m-0">
          <i class="material-icons task-icon-color">fact_check</i><b class="bold-item">&nbsp;Intrucciones:&nbsp;</b>
          {{taskRequest.description}}
        </h5>
      </div>
    </div>

    <div class="row font-manax" *ngIf="taskRequest?.attachments?.length || 0 > 0">
      <div class="col-12 pb-3">
        <h5 class="m-0">
          <i class="material-icons task-icon-color">attach_file</i><b class="bold-item">&nbsp;Archivos adjuntos:</b>
        </h5>
      </div>
      <div class="col-12">
        <ng-container *ngFor="let file of taskRequest.attachments">
          <!-- Validar luego si es una imagen con todos sus tipos de formato o no -->
          <img *ngIf="(file.fileUrl).substring(file.fileUrl?.length - 3) !== 'pdf'"
            class="image-preview cursor-pointer p-1" [src]="file.fileUrl" (click)="openFile(file)"
            style="max-width: 150px; max-height: 150px;" />
          <img *ngIf="(file.fileUrl).substring(file.fileUrl?.length - 3) == 'pdf'"
            class="image-preview cursor-pointer p1-1" src="/assets/img/pdf-image.png" (click)="openPdf(file)"
            style="max-width: 100px; max-height: 100px;" />
        </ng-container>
      </div>
    </div>

    <div class="row my-3">
      <div class="col-12 text-center d-flex" style="justify-content: space-around;"
        *ngIf="!loading && taskRequest?.status === 'PENDING'">
        <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-manax" *ngIf="!loading"
          (click)="openTaskRequestClient()">
          Aceptar
        </button>

        <button mat-raised-button type="button" class="m-0 mt-2 ml-2 px-3 btn btn-outline-danger" *ngIf="!loading"
          (click)="openRejectedTaskRequestConfirm()">
          Rechazar
        </button>
      </div>
    </div>
  </div>
</div>